
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacts/[contactId]",
      function () {
        return require("private-next-pages/contacts/[contactId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contacts/[contactId]"])
      });
    }
  